"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerProvider = void 0;
const loggers_browser_1 = require("./loggers-browser");
const logger_base_1 = require("./logger-base");
class LoggerProvider extends logger_base_1.LoggerProviderBase {
    _makeDiagnosticLogger() {
        return new loggers_browser_1.DiagnosticsLogger(this.config.logLevel);
    }
    makeServiceLogger(serviceName) {
        return new loggers_browser_1.ServiceLogger(serviceName, this.config.logLevel);
    }
}
exports.LoggerProvider = LoggerProvider;
